import { render, staticRenderFns } from "./UserPermissionBadge.vue?vue&type=template&id=68d212b1"
import script from "./UserPermissionBadge.vue?vue&type=script&lang=js"
export * from "./UserPermissionBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports